"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanStringForSearch = exports.getClassName = void 0;
const getClassName = (...classes) => (classes.filter(Boolean).join(' '));
exports.getClassName = getClassName;
const cleanStringForSearch = (string) => string?.toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\p{L}\p{N}\p{P}\p{Z}{^$}]/gu, '')
    .replace(/\s\s+/g, ' ')
    .trim();
exports.cleanStringForSearch = cleanStringForSearch;
//# sourceMappingURL=string.js.map